// extracted by mini-css-extract-plugin
export var ckw = "Icon-module--ckw--47864";
export var icon = "Icon-module--icon--b3d78";
export var inverted = "Icon-module--inverted--deb33";
export var primary = "Icon-module--primary--80e23";
export var rating = "Icon-module--rating--72182";
export var secondary = "Icon-module--secondary--2b290";
export var social = "Icon-module--social--9544c";
export var spin = "Icon-module--spin--82ce0";